import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import MeasurementEditDto from '../dto/MeasurementEditDto';

class MeasurementEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'measurementEditControl';
	}

	/**
	 * @return {Promise<MeasurementEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new MeasurementEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<MeasurementEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new MeasurementEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {MeasurementEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {MeasurementEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new MeasurementEditService();
